import React from "react";
import classNames from "classnames";
import {
    FILE_TYPE_ICONS,
    splitFileName,
} from "@design-system/FileTypeIcon/fileType";

interface Props {
    filename: string;
    className?: string;
}

export const FinancialDocumentExtensionIcon: React.FC<Props> = ({
    filename,
    className,
}) => {
    const { extension } = splitFileName(filename);
    const ExtensionIconComponent =
        extension === null
            ? undefined
            : FILE_TYPE_ICONS[extension.toLowerCase()];

    if (!ExtensionIconComponent) {
        return null;
    }

    return (
        <ExtensionIconComponent
            className={classNames(className, "icon-color-revert")}
        />
    );
};
